/**
 * Upload catalog/site images via /upload_image.php (admin session required).
 * @returns {Promise<string>} server path e.g. /serve_upload.php?f=…
 */
export async function uploadAdminImage(sessionToken, file) {
  if (!file) throw new Error('No file selected.');

  const formData = new FormData();
  formData.append('image', file);
  const tok = String(sessionToken || '').trim();
  const headers = {};
  if (tok) {
    headers['X-Admin-Session'] = tok;
    headers.Authorization = `Bearer ${tok}`;
  }

  const response = await fetch('/upload_image.php', {
    method: 'POST',
    headers,
    body: formData,
  });

  const text = await response.text();
  const plainSnippet = String(text || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 400);

  const postTooLarge =
    /POST Content-Length of \d+ bytes exceeds the limit|exceeds the limit of \d+ bytes|post_max_size|upload_max_filesize/i.test(
      text
    );

  let result = {};
  try {
    result = text ? JSON.parse(text) : {};
  } catch {
    if (postTooLarge) {
      throw new Error(
        'Upload was rejected because the file is larger than PHP allows. Use npm run php:serve for local dev.'
      );
    }
    throw new Error(
      response.ok
        ? 'Upload response was not JSON. Is PHP running and upload_image.php reachable?'
        : `Upload failed (HTTP ${response.status}). ${plainSnippet || 'Unknown error.'}`
    );
  }

  if (!response.ok || !result.success) {
    if (postTooLarge && (!result.error || String(result.error).trim() === '')) {
      throw new Error('Upload was rejected because the file is larger than PHP allows.');
    }
    throw new Error(result.error || plainSnippet || 'Upload error');
  }

  return String(result.path || '').trim();
}
